import React from 'react';
import createPaymentService from './paymentService';

const PaymentContext = React.createContext({
  stripe: {},
  service: createPaymentService('', ''),
});

export default PaymentContext;
